/*
 * Keeps the two-segment indicator on a product card in sync with the card's
 * swipe position. The swipe itself is native scrolling — see the mobile swipe
 * block in main-collection.css; this file only paints the indicator.
 *
 * Scroll events do not bubble, so the listener runs in the capture phase on
 * the grid. That also means cards appended by the infinite scroll are covered
 * without rebinding anything when the next page arrives.
 */
(function () {
  /* Bound on the document: cards also live in the search results, the SALE
   * grid, the home rows and the recommendations, none of which is
   * #product-grid, and the arrows there did nothing. */
  var grid = document;

  function paint(scroller) {
    var dots = scroller.parentElement.querySelectorAll('.minimal-card-dot');
    if (!dots.length) return;

    // clientWidth is one slide: each image is flex: 0 0 100% of the scroller.
    var slide = scroller.clientWidth || 1;
    var index = Math.round(scroller.scrollLeft / slide);

    for (var i = 0; i < dots.length; i++) {
      dots[i].classList.toggle('is-active', i === index);
    }
  }

  var pending = null;
  var frame = null;

  grid.addEventListener(
    'scroll',
    function (event) {
      var scroller = event.target;
      if (!scroller.classList || !scroller.classList.contains('minimal-card-link')) return;

      // One finger means one card at a time, so a single queued frame is
      // enough; the newest scroller always wins.
      pending = scroller;
      if (frame) return;
      frame = requestAnimationFrame(function () {
        frame = null;
        paint(pending);
      });
    },
    true
  );

  /* Desktop arrows (nc-minimal-card): one photo per click. */
  grid.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-card-nav]');
    if (!btn) return;
    event.preventDefault();
    event.stopPropagation();
    var scroller = btn.parentElement.querySelector('.minimal-card-link');
    if (!scroller) return;
    scroller.scrollBy({ left: Number(btn.dataset.cardNav) * scroller.clientWidth, behavior: 'smooth' });
  });
})();
